import React from "react";

export interface IconProps {
  width?: number;
  height?: number;
  color?: string;
}

export default function TriangleAlert(props: IconProps): JSX.Element {
  const { width, height, color } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width || "16"}
      height={height || "14.222"}
      viewBox="0 0 16 14.222"
    >
      <path
        id="Path_10326"
        data-name="Path 10326"
        d="M15.82,12.723,9.155,1.166a1.334,1.334,0,0,0-2.31,0L.18,12.723a1.334,1.334,0,0,0,1.155,2h13.33A1.334,1.334,0,0,0,15.82,12.723ZM8,10.333a1.278,1.278,0,1,1-1.278,1.278A1.278,1.278,0,0,1,8,10.333ZM6.787,5.74a.333.333,0,0,1,.333-.352H8.88a.333.333,0,0,1,.333.352L9.007,9.518a.333.333,0,0,1-.333.315H7.326a.333.333,0,0,1-.333-.315Z"
        transform="translate(0 -0.5)"
        fill={color || "#c40000"}
      />
    </svg>
  );
}
